import React, { forwardRef, useState } from 'react'
import {
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import DataService from '../services/data.service';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const useStyles = makeStyles((theme) => ({
  navlinks: {
    display: "flex",
  },
  logo: {
    marginLeft: '5%',
    flexGrow: "0.8",
    cursor: "pointer",
  },
  link: {
    textDecoration: "none",
    color: "black",
    fontSize: "15px",
    fontWeight: "600",
    padding: "10px",
    "&:hover": {
      color: "#a31e21"
    },
  },
}));

export const NavbarDrawer = () => {
  const [loading, setLoading] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [failOpen, setFailOpen] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const classes = useStyles();
  const url = (window.location.href).split('/')[3];
  const [show, setShow] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [adsType, setAdsType] = useState("");
  const [influenceMarketing, setInfluenceMarketing] = useState("");
  const [country, setCountry] = useState("");
  const [region, setRegion] = useState("");
  const [city, setCity] = useState("");
  const formType = 'requirement';

  const handleCloseSnackBar = (event, reason) => {
    setSuccessOpen(false);
    setFailOpen(false);
  };

  const handleAction = () => {
    setShow(true);
    setOpenDrawer(!openDrawer);
  }

  const handleClose = () => setShow(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const data = new FormData();
    data.append('name', firstName + " " + lastName);
    data.append('email', email);
    data.append('phone', phone);
    data.append('adsType', adsType);
    data.append('influenceMarketing', influenceMarketing);
    data.append('country', country);
    data.append('state', region);
    data.append('city', city);
    data.append('formType', formType);

    DataService.sendMail(data)
      .then((response) => {
        if (response.message === 'success') {
          setSuccessOpen(true);
          setLoading(false);
        }
        else {
          setFailOpen(true);
          setLoading(false);
        }
        setShow(false)
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhone("");
        setAdsType("");
        setInfluenceMarketing("");
        setCountry("");
        setRegion("");
        setCity("");
      })
  }

  return (
    <>
      <Snackbar open={successOpen} autoHideDuration={10000} onClose={handleCloseSnackBar}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          This is a success message!
        </Alert>
      </Snackbar>
      <Snackbar open={failOpen} autoHideDuration={10000} onClose={handleCloseSnackBar}>
        <Alert onClose={handleClose} severity="warning" sx={{ width: '100%' }} >
          This is a warning message!
        </Alert>
      </Snackbar>
      <div>
        <Drawer open={openDrawer} style={{ width: '30%' }}
          onClose={() => setOpenDrawer(false)}>
          <List>
            <ListItem>
              <ListItemText>
                {
                  url === "" ?
                    <Link className={classes.link} to="/">
                      <span style={{ color: '#a31e21', padding: '9px' }}>Home</span>
                    </Link>
                    :
                    <Link className={classes.link} to="/">
                      <span style={{ padding: '9px' }}>Home</span>
                    </Link>
                }
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                {
                  url === "services" ?
                    <>
                      <div class="dropdown1">
                        <span className={classes.link}>
                          <span style={{ color: '#a31e21', cursor: 'pointer' }}>Services</span>
                        </span>
                        <div class="dropdown-content">
                          <Link to="/services/seo-and-web-analytics">
                            <span className={classes.link}>SEO & Web Analytics</span>
                          </Link>
                          <Link to="/services/online-advertisement">
                            <span className={classes.link}>Online Advertisement</span>
                          </Link>
                          <Link to="/services/poster-and-logo-design">
                            <span className={classes.link}>Poster & Logo Design</span>
                          </Link>
                          <Link to="/services/web-design-and-development">
                            <span className={classes.link}>Web Design & Development</span>
                          </Link>
                          <Link to="/services/video-editing-and-animation">
                            <span className={classes.link}>Video Editing & Animation</span>
                          </Link>
                        </div>
                      </div>
                    </>
                    :
                    <div class="dropdown1">
                      <span className={classes.link}>
                        <span style={{ cursor: 'pointer' }}>Services</span>
                      </span>
                      <div class="dropdown-content">
                        <Link to="/services/seo-and-web-analytics">
                          <span className={classes.link}>SEO & Web Analytics</span>
                        </Link>
                        <Link to="/services/online-advertisement">
                          <span className={classes.link}>Online Advertisement</span>
                        </Link>
                        <Link to="/services/poster-and-logo-design">
                          <span className={classes.link}>Poster & Logo Design</span>
                        </Link>
                        <Link to="/services/web-design-and-development">
                          <span className={classes.link}>Web Design & Development</span>
                        </Link>
                        <Link to="/services/video-editing-and-animation">
                          <span className={classes.link}>Video Editing & Animation</span>
                        </Link>
                      </div>
                    </div>
                }
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                {
                  url === "contact" ?
                    <Link className={classes.link} to="/contact">
                      <span style={{ color: '#a31e21', padding: '9px' }}>Contact</span>
                    </Link>
                    :
                    <Link className={classes.link} to="/contact">
                      <span style={{ padding: '9px' }}>Contact</span>
                    </Link>
                }
              </ListItemText>
            </ListItem>
            <ListItem >
              <ListItemText>
                <div class="border-first-button" onClick={handleAction}>
                  <span>Free Quote</span>
                </div>
              </ListItemText>
            </ListItem>
          </List>
        </Drawer>
        <IconButton onClick={() => setOpenDrawer(!openDrawer)} style={{ position: 'relative', float: 'left' }}>
          <MenuIcon />
        </IconButton>
      </div>
      <Modal show={show} onHide={handleClose} size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div id="contact" class="section">
          <div class="row">
            <div class="col-lg-12 wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="0.25s">
              <form id="contact" onSubmit={handleSubmit}>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="fill-form">
                      <div className='row' style={{ textAlign: 'start' }}>
                        <div className='col-md-6'>
                          <label className='form-label'>Name <span style={{ color: 'red' }}> *</span></label>
                          <input type="text" placeholder='First Name' className='form-control inputbox' required
                            value={firstName} onChange={e => setFirstName(e.target.value)}></input>
                        </div>
                        <div className='col-md-6'>
                          <label className='form-label'><span style={{ color: 'transparent' }}> *</span></label>
                          <input type="text" placeholder='Last Name' className='form-control inputbox' required
                            value={lastName} onChange={e => setLastName(e.target.value)}></input>
                        </div>
                        <div className='col-md-6'><br />
                          <label className='form-label'>Email <span style={{ color: 'red' }}> *</span></label>
                          <input type="text" placeholder='Your Email' className='form-control inputbox' required
                            value={email} onChange={e => setEmail(e.target.value)}></input>
                        </div>
                        <div className='col-md-6'><br />
                          <label className='form-label'>Phone <span style={{ color: 'red' }}> *</span></label>
                          <input type="text" placeholder='Your Phone' className='form-control inputbox' required
                            value={phone} onChange={e => setPhone(e.target.value)}></input>
                        </div>
                        <div className='col-md-6'><br />
                          <label className='form-label'>Advertisement Type <span style={{ color: 'red' }}> *</span></label>
                          <select className='form-control inputbox' required value={adsType} onChange={e => setAdsType(e.target.value)}>
                            <option>Select</option>
                            <option>L Shape Video</option>
                            <option>Short Promo Video (30 seconds)</option>
                            <option>Full Promo Video (10 - 30 minutes)</option>
                          </select>
                        </div>
                        <div className='col-md-6'><br />
                          <label className='form-label'>Influence Marketing <span style={{ color: 'red' }}> *</span></label>
                          <select className='form-control inputbox' required value={influenceMarketing} onChange={e => setInfluenceMarketing(e.target.value)}>
                            <option>Select</option>
                            <option>Yes</option>
                            <option>No</option>
                          </select>
                        </div>
                        <div className='col-12'><br /></div>
                        <div className='col-md-4'>
                          <label className='form-label'>Location <span style={{ color: 'red' }}> *</span></label>
                          <input type="text" placeholder="Country" className='form-control inputbox' required
                            value={country} onChange={e => setCountry(e.target.value)} />
                        </div>
                        <div className='col-md-4'>
                          <label className='form-label'><span style={{ color: 'transparent' }}> *</span></label>
                          <input type="text" placeholder="State" className='form-control inputbox' required
                            value={region} onChange={e => setRegion(e.target.value)} />
                        </div>
                        <div className='col-md-4'>
                          <label className='form-label'><span style={{ color: 'transparent' }}> *</span></label>
                          <input type="text" placeholder="City" className='form-control inputbox' required
                            value={city} onChange={e => setCity(e.target.value)} />
                        </div>
                        <div className='col-md-3'></div>
                        <div className='col-md-6'>
                          {
                            loading ?
                              <button type="submit" className='btn-submit' disabled>
                                <span className="spinner-border spinner-border-sm"></span>&nbsp;
                                Loading...
                              </button>
                              :
                              <button type="submit" className='btn-submit'>
                                Submit
                              </button>
                          }
                        </div>
                        <div class="border-first-button btn-hidden-submit" >
                          <span>Submit</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
